// A small read-only pill list — e.g. which zones a recipe targets, which equipment serves a
// zone. Display-only, not clickable; for an interactive/toggleable pill use Chip
// (@/components/control-tower/Chip) instead.
export function TagPillRow({ names }: { names: string[] }) {
  if (names.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1">
      {names.map((name) => (
        <span
          key={name}
          className="rounded-full border border-border/60 bg-muted/40 px-2 py-0.5 text-[10px] text-muted-foreground"
        >
          {name}
        </span>
      ))}
    </div>
  );
}
